module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-BA.bb8e7f0b.png";